import "./app.css";
import "./Website/WebCss/web.css";
import { Routes, Route } from "react-router-dom";
import NotFoundPage from "./Components/NotFoundPage";
import { Row } from "react-bootstrap";
import ScrollTop from "./Website/Component/ScrollTop";
import Home from "./Home";


function App() {
  return (
    <>
      <Row className="p-0 m-0 translater-tab">
        <div id="google_translate_element"></div>
      </Row>
      <ScrollTop />
      <Routes>
        {/* web routes start*/}
        <Route path="/" element={<Home />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
export default App;
